import { component$, useSignal, useVisibleTask$ } from "@builder.io/qwik";
import { LifetimeDealModal } from "./lifetime-deal-modal";

const SESSION_KEY = "lifetime_deal_modal_shown";

export const SessionLifetimeDealModal = component$(() => {
  const isOpen = useSignal(false);

  // Only runs on the front-end
  // eslint-disable-next-line qwik/no-use-visible-task
  useVisibleTask$(() => {
    const hasShown = sessionStorage.getItem(SESSION_KEY);
    if (!hasShown) {
      isOpen.value = true;
      sessionStorage.setItem(SESSION_KEY, "true");
    }
  });

  return (
    <LifetimeDealModal
      isOpen={isOpen}
      onClose$={() => {
        isOpen.value = false;
      }}
      variant="public"
    />
  );
});
